<div class="container-fluid footer-style">
    <div class="d-flex py-2 text-white-50 company-name">
        <span>&#169; {{ currentYear }}.</span>
        <span class="ms-auto">Version 1.0.0.3 | Development | Designed By
            <a class="ms-1 text-white-50" target="_blank" rel="noopener noreferrer" href="https://portalwiz.com/">Portalwiz Technologies</a>
        </span>
    </div>
</div>
